<template>
<div class="container">
  <footer class="fluid-container bg-dark">
    <a href="https://www.facebook.com/groups/LudosphereCarquefolienne">
      <img src="@/assets/fb.svg" class="fb-img"><span class="text">Notre groupe Facebook</span>
    </a>
    <a href="https://discord.gg/QPbEwAX">
      <img src="@/assets/Discord-Logo-White.svg" class="discord-img"><span class="text">Notre groupe Discord</span>
    </a>
    <a href="mailto:laludospherecarquefolienne@yahoo.com">
      <i class="far fa-envelope"></i><span class="text">Nous contacter</span>
    </a>
    <span class="copyright">&copy; Ludosphere Carquefolienne</span>
    <img src="@/assets/logo_carquefou.png" class="carquefou-img" title="Avec le soutien de la Ville de Carquefou">
  </footer>
</div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding: 5px 0;
  margin: 0;
  height: 2em;
  text-align: center;
}

footer p {
  margin: 0;
}

.container {
  width: 100%;
  height: 3em;
  margin: 0;
  padding: 0;
}

a, i, img {
  margin: 0 5px;
  color: white;
}

.copyright {
  font-size: 10px;
  color: lightgrey;
}

img {
  vertical-align: baseline;
}

.fb-img{
  height: 16px;
}

.discord-img{
  height: 22px;
  position: relative;
  top: 4px;
}

.carquefou-img{
  height: 100%;
  float: right;
}

@media (max-width: 700px) {
  .text{
    display: none;
  }
}

</style>
